import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {ProgressBar} from '@freckle/educator-materials/ts/components/progress-bar'
import {UploadFileButton} from '@freckle/educator-materials/ts/components/upload-file-button'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {RosterFileTypeT} from '@freckle/school/ts/rostering/components/import-roster/import-roster-container/utils'
import {getFileName} from '@freckle/school/ts/rostering/components/import-roster/import-roster-container/utils'
import type {AttachedStatusT} from './../index'
import {
  progressWrapper,
  attachCsvWrapper,
  filenameStyle,
  attachmentProgressBar,
  removeBtn,
  removeBtnErrorTheme,
  errorMessage,
  errorIcon
} from './attach-csv.module.scss'

type Props = {
  fileType: RosterFileTypeT
  onAttach: (file: File, fileType: RosterFileTypeT) => void
  onRemove: (fileType: RosterFileTypeT) => void
  attachedStatus: AttachedStatusT
}

export default function AttachRosterCsv(props: Props) {
  const {fileType, onAttach, onRemove, attachedStatus} = props
  const {t} = useSafeTranslation()

  return (
    <div className={attachCsvWrapper} data-test={`attach-roster-csv-${fileType}`}>
      <span className={filenameStyle}>
        <strong>{getFileName(t, fileType)}</strong>
      </span>

      <AttachedStatusBar attachedStatus={attachedStatus} />

      {attachedStatus === 'success' || attachedStatus === 'error' ? (
        <Button
          style="tertiary"
          className={`${removeBtn} ${attachedStatus === 'error' ? removeBtnErrorTheme : ''}`}
          onClick={() => onRemove(fileType)}
          dataTest="rostering-remove-attached-csv-file"
        >
          {t('ATTACH_ROSTER_CSV_BUTTON_REMOVE')}
        </Button>
      ) : (
        <UploadFileButton
          buttonText={t('ATTACH_ROSTER_CSV_BUTTON_CHOOSE_FILE')}
          onPostFileUpload={file => onAttach(file, fileType)}
        />
      )}
    </div>
  )
}

type AttachedStatusBarProps = {
  attachedStatus: AttachedStatusT
}

function AttachedStatusBar(props: AttachedStatusBarProps) {
  const {attachedStatus} = props
  const {t} = useSafeTranslation()

  if (attachedStatus === 'success' || attachedStatus === 'not-attached') {
    return (
      <div className={progressWrapper}>
        <ProgressBar
          className={attachmentProgressBar}
          label={t('ATTACH_ROSTER_CSV_PROGRESS_BAR_LABEL')}
          value={attachedStatus === 'success' ? 100 : 0}
        />
      </div>
    )
  } else {
    return (
      <div className={progressWrapper}>
        <div className={errorMessage}>
          <FontAwesomeIcon className={errorIcon} icon={faExclamationTriangle} />
          {t('ATTACH_ROSTER_CSV_ERROR_FILE_TOO_LARGE')}
        </div>
      </div>
    )
  }
}
